<body>
  <section class="title-container text-center" id="imageBox">
    <h1 class="club-name">ŽUPNIJA HOTEDRŠICA</h1>
  
    <div class="d-flex justify-content-center align-items-center mt-3">
      <img 
      class="bg-img" 
      ngSrc="/assets/images/organisations/church/background1.jpg"
      width="1920" height="1080"
      fetchpriority="high"
      priority
      alt="Background of Church page">
    </div>
  </section>

<section id="navbar">
  <div id="orgBar" class="container-fluid">
    <button id="burger" (click)="toggleMenu()">☰</button>
    <div id="menu" [ngClass]="{ 'show': menuOpen }">
      <button class="org-button" (click)="scrollTo('introduction')">KDO SMO</button>
      <button class="org-button" (click)="scrollTo('news')">NOVICE</button>
      <button class="org-button" (click)="scrollTo('gallery-section')">GALERIJA</button>
      <button class="org-button" (click)="scrollTo('oznanila')">OZNANILA</button>
      <button class="org-button" (click)="scrollTo('parish-details')">PODATKI ŽUPNIJE</button>
    </div>
  </div>
</section>

<section id="oznanila" class="p-5 pt-5">
  <h1 class="club-name animated-title mb-5 text-center">OZNANILA</h1>
  
  <div class="container mt-5">
    <div *ngIf="organisationId" id="report-section" class="card shadow-lg border-0 h-100 mt-3 animated-text">
      <app-report-list 
        [orgID]="organisationId" 
        [isAdmin]="isOrgAdmin || isSuperAdmin">
      </app-report-list>
    </div>
  </div>
</section>

  <section id="introduction" class="history-container container">
    <h1 class="club-name animated-title mb-5">CERKEV JANEZA KRSTNIKA</h1>
    <p class="animated-text fs-6">Župnijska cerkev sv. Janeza Krstnika stoji ob vzhodnem robu vasi Hotedršica. Obdana je spredaj s t.i.
        Plečnikovim stopniščem, desno je župnišče z gospodarskim poslopjem, na levi nižji strani pa stoji
        nekdanje šolsko poslopje. Ob straneh cerkve je obzidje, ki je nekdaj služilo za pokopališče.
        Pokopališče se zdaj nahaja v ozadju cerkve in objema le še njen prezbiterij. Ni znano, kdaj je bila
        zgrajena prva cerkev in kaj se je dogajalo z njo.</p>
    <p class="animated-text fs-6">Uradni zapis iz leta 1506 govori o posvetitvi desnega oltarja in pokopališča. Današnji zvonik je bil
        zgrajen leta 1707, kar priča vklesana letnica na njem.
        Po uničujočem požaru 26. oktobra 1866, ko sta zgorela streha in zvonik, so kmetje leta 1869 pričeli
        graditi novo cerkev, ki je bila posvečena 3. septembra 1873. Oltarje in prižnico je izdelal podobar Jurij
        Tavčar iz Idrije, orgle je postavil Fran Goršič, freske pa so delo Čeha Jožefa Hubscha. Grobnica stare
        cerkve je na žalost zasuta, nekaj slik in kipov iz stare cerkve pa se hrani v zasebnih zbirkah.
        Leta 1935 so po načrtih arhitekta Jožefa Plečnika uredili prostor okoli cerkve in župnišča. Izvedba
        načrta ob vhodu na pokopališče pa je ostala nerealizirana, stebri so zdaj na grobu, kjer so pokopani
        duhovniki.</p>
  </section>

  <div class="curvy-container">
    </div>
  <!-- News Section -->
  <section id="news" class="p-1 pt-5">
    <h1 class="club-name animated-title">NOVICE</h1>
    <app-news-list 
    [organisation]="organisation" 
    [isSuperAdmin]="isSuperAdmin" 
    [isOrgAdmin]="isOrgAdmin" 
    [news]="news"
    [totalNewsCount]="totalItems"
    (loadMoreClicked)="loadMoreNews()"
    (newsChanged)="handleNewsChanged()"
    ></app-news-list>
  </section>

  <!--Galerija-->
<section id="gallery-section">
    <h1 class="font-weight-bold club-name animated-title">GALERIJA</h1>
    <div class="container p-5 animated-title">
        <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="churchImages" (thumbClick)="onThumbClick($event)"></gallery>
        <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn button-74 mt-3" (click)="openAddSportsImagesModal()">
        <fa-icon class="fa-lg me-2" [icon]="faPlus"></fa-icon>Dodaj slike</button>
        <button *ngIf="imageSelected && (isOrgAdmin || isSuperAdmin)" (click)="deleteSelectedImage()" class="btn button-74 mt-3">
        <fa-icon class="fa-lg me-2" [icon]="faTrash"></fa-icon>Izbriši izbrano sliko
        </button>
    </div>
</section>

  <div class="curvy-container-inv">
  </div>


<section id="parish-details" class="parish-details p-2">
  <h1 class="club-name animated-title mb-5 text-center">PODATKI ŽUPNIJE</h1>

  <div class="container mt-5">
    <div class="row g-4 animated-text">
      <!-- Left column -->
      <div class="col-md-6 d-flex flex-column">
        <!-- General Parish Information -->
        <div class="card shadow-lg border-0 flex-grow-1">
          <div class="card-body">
            <h3 class="card-title mb-0" style="color: #ffc300;">Osnovni podatki</h3>
            <hr>
            <p class="mb-2"><strong>Škofija:</strong> Nadškofija Ljubljana</p>
            <p class="mb-2"><strong>Cerkev:</strong> Župnijska cerkev sv. Janeza Krstnika</p>
            <p class="mb-2"><strong>Zavetnik:</strong> sv. Janez Krstnik</p>
          </div>
        </div>

        <!-- Address and Contact -->
        <div class="card shadow-lg border-0 flex-grow-1 mt-3">
          <div class="card-body">
            <h3 class="card-title mb-0" style="color: #ffc300;">Kontaktni podatki</h3>
            <hr>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faHouse" style="color: #ffc300;"></fa-icon>
              Hotedršica 63
            </p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faEnvelopeOpenText" style="color: #ffc300;"></fa-icon>
              Pošta: Hotedršica
            </p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faMapMarkerAlt" style="color: #ffc300;"></fa-icon>
              Poštna številka: 1372
            </p>
            <p class="mb-2">
              <fa-icon class="me-2" [icon]="faPhone" style="color: #ffc300;"></fa-icon>
              01 / 755 91 11
            </p>
          </div>
        </div>
      </div>

      <!-- Right column -->
      <div class="col-md-6 d-flex flex-column">
        <!-- Mass Schedule -->
        <div class="card shadow-lg border-0 flex-grow-1">
          <div class="card-body">
            <h3 class="card-title mb-0" style="color: #ffc300;">Urnik maš</h3>
            <hr>
            <p><strong>Maše ob delavnikih (poletni čas):</strong> 18.30</p>
            <p><strong>Maše ob delavnikih (zimski čas):</strong> 17.00</p>
            <p><strong>Nedeljske maše (poletni čas):</strong> 8.30</p>
            <p><strong>Nedeljske maše (zimski čas):</strong> 8.30</p>
          </div>
        </div>
          <div class="card shadow-lg border-0 flex-grow-1 mt-3">
          <div class="card-body">
            <h3 class="card-title mb-3 text-center" style="color: #ffc300;">Zemljevid</h3>
            <div id="map" class="rounded shadow-sm" style="height: 200px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


  
</body>